/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeconferencesbtn2Inputs */



/**
* | output |
* | --- |
* | "To the conferences" |
*
* @param {Homeconferencesbtn2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeconferencesbtn2 = /** @type {((inputs?: Homeconferencesbtn2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeconferencesbtn2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("To the conferences")
	return /** @type {LocalizedString} */ ("Zu den Konferenzen")
});
export { homeconferencesbtn2 as "homeConferencesBtn" }